export default __webpack_public_path__ + "static/media/ball.c413ff1d.svg";